






























import {Component, Prop, Watch} from 'vue-property-decorator';
import PagedTable from '@/components/Views/Dashboard/PagedTable.vue';
import {Mixins} from 'vue-property-decorator';
import CurrencyMixin from '@/mixins/CurrencyMixin.vue';
import ImportDialog from '@/components/Views/Dashboard/Import & Export/ImportDialog.vue';
import ExportDialog from '@/components/Views/Dashboard/Import & Export/ExportDialog.vue';
import {BOOKING_STATUS, nil, serviceHeaders} from '@/common';
import ServiceDialog from '@/components/Views/Purchasables/ServiceDialog.vue';
import GenericDeleteDialog from '@/components/Views/UI/GenericDeleteDialog.vue';
import {FeathersVuexFindAll} from '@/utils';

@Component({
    components: {GenericDeleteDialog, ServiceDialog, ExportDialog, ImportDialog, PagedTable},
})
export default class Services extends Mixins(CurrencyMixin) {

    @Prop({default: () => (() => {})})
    public addToQuery!: () => any;

    @Prop({default: true})
    public showControls!: boolean;

    public editingService: any = null;

    private selectedServices: any[] = [];
    private selectedTier = null;
    private tiers: any[] = [];
    private selectedCategory = null;
    private categories: any[] = [];
    private search = '';
    private services: any[] = [];

    public mounted() {
        this.initialize();
    }

    private async initialize() {
        const tiersResponse = await this.$FeathersVuex.Tier.find({});
        const categoriesResponse = await this.$FeathersVuex.Category.find({});
        this.tiers = tiersResponse.data;
        this.categories = categoriesResponse.data;
    }

    @Watch('selectedTier')
    private onSelectedTierChanged(value: string, oldValue: string) {
        (this.$refs.table as any).refresh(true);
    }

    @Watch('selectedCategory')
    private onSelectedCategoryChanged(value: string, oldValue: string) {
        (this.$refs.table as any).refresh(true);
    }

    @Watch('search')
    private onSearchChanged(value: string, oldValue: string) {
        (this.$refs.table as any).refresh(true);
    }

    public onCreate() {
        this.editingService = null;
        (this.$refs.serviceDialog as any).openWith(null);
    }
    private get exportableServices() {
        return this.selectedServices.map((x) => ({
            _id: x._id,
            name: x.name,
            displayName: x.displayName,
            displayNameSubtitle: x.displayNameSubtitle,
            description: x.description,
            serviceTypes: nil(x.serviceTypeModels) ? '' : x.serviceTypeModels.map((stm) => stm.name).join(', '),
            vendorCut: x.vendorCut,
            category: x.categoryModel.name,
            tier: x.tierModel.name,
            price: x.price,
        }));
    }
    public get headers() {
        return serviceHeaders;
    }
    private get searchQuery() {
        return nil(this.search) || this.search === '' ? undefined : {
            name: {$search: this.search.toString()},
        };
    }
    private async deleteRefreshBookings() {
        if (nil(this.editingService)) { return; }
        const {Booking} = this.$FeathersVuex;
        const content = await FeathersVuexFindAll(Booking, {
            query: {
                service: this.editingService._id,
                status: {$ne: BOOKING_STATUS.FULFILLED},
            },
        });
        const bookings = [];
        if (content.length > 0) {
            bookings.push({title: 'Used In These Not Yet Fulfilled Bookings', content});
        }
        return bookings;
    }


    private get tierQuery() {
        return nil(this.selectedTier) ? undefined : {
            tier: this.selectedTier,
        };
    }

    private get categoryQuery() {
        return nil(this.selectedCategory) ? undefined : {
            category: this.selectedCategory,
        };
    }

    private onEdit(item: any) {
        this.editingService = Object.assign({}, item);
        (this.$refs.serviceDialog as any).openWith(item);
    }
    private onDelete(item: any) {
        this.editingService = Object.assign({}, item);
        (this.$refs.deleteDialog as any).open = true;
    }
    public onDeleted() {
        this.editingService = null;
        (this.$refs.table as any).refresh(true);
    }
    private onQuery() {
        return {
            ...this.searchQuery,
            ...this.tierQuery,
            ...this.categoryQuery,
            ...this.addToQuery(),
        };
    }
}
